import React from 'react';
import { CheckIcon } from 'lucide-react';
type CheckItemProps = {
  children: React.ReactNode;
  className?: string;
};
export function CheckItem({
  children,
  className = ''
}: CheckItemProps) {
  return <li className={`flex items-start gap-1.5 ${className}`} data-id="element-21" data-mp="2746931bmdycf">
      <CheckIcon className="mt-[3px] h-4 w-4 shrink-0 text-green-600" strokeWidth={3} aria-hidden data-id="element-22" data-mp="2c2hlnjtaumyc" />
      <span data-id="element-23" data-mp="1x5701hmy00ow">{children}</span>
    </li>;
}